let activeOverlay = null;

function getZoomImageUrl(image) {
  const srcset = image.getAttribute('srcset');
  if (srcset) {
    let bestUrl = image.currentSrc || image.src;
    let bestWidth = 0;

    srcset.split(',').forEach((entry) => {
      const parts = entry.trim().split(/\s+/);
      const url = parts[0];
      const width = parseInt(parts[1], 10) || 0;
      if (width > bestWidth) {
        bestWidth = width;
        bestUrl = url;
      }
    });

    return bestUrl;
  }

  return image.currentSrc || image.src;
}

function createOverlay(image, imageUrl) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', imageUrl);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, imageUrl);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  overlayImage.onerror = () => {
    toggleLoadingSpinner(image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, imageUrl) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${imageUrl}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector('.loading__spinner');
  loadingSpinner?.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.currentTarget.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio, event) {
  if (activeOverlay) {
    activeOverlay.remove();
    activeOverlay = null;
    return;
  }

  const imageUrl = getZoomImageUrl(image);
  const overlay = createOverlay(image, imageUrl);
  activeOverlay = overlay;

  overlay.onclick = (clickEvent) => {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();
    overlay.remove();
    activeOverlay = null;
  };

  overlay.onmousemove = (moveEvent) => moveWithHover(image, overlay, moveEvent, zoomRatio);
  overlay.onmouseleave = () => {
    overlay.remove();
    activeOverlay = null;
  };

  moveWithHover(image, overlay, event, zoomRatio);
}

function enableZoomOnHover(zoomRatio, root = document) {
  root.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (image.dataset.zoomBound === 'true') return;
    image.dataset.zoomBound = 'true';

    image.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        magnify(image, zoomRatio, event);
      },
      true
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => enableZoomOnHover(2));
} else {
  enableZoomOnHover(2);
}

document.addEventListener('product-info:loaded', () => enableZoomOnHover(2));
document.addEventListener('product-gallery:updated', (event) => {
  const root = event.detail?.root || document;
  enableZoomOnHover(2, root);
});
